import React from 'react';

import { Svg } from '@lglp/components';

import styles from './LogoGLP.module.scss';

const LogoGLP: React.FC<LogoGLPProps> = ({ className, ...rest }) => {
  return (
    <Svg viewBox="0 0 53.49611 16.965992" className={className} {...rest}>
      <defs>
        <linearGradient>
          <stop className={styles.cls1} offset="0" />
        </linearGradient>
        <linearGradient>
          <stop className={styles.cls1} offset="0" id="stop870" />
        </linearGradient>
      </defs>
      <g className={styles.cls2} transform="translate(140.16893,6.2853003)">
        <path
          className={styles.cls2}
          d="m -127.99684,-6.2853003 8.73802,5.0220466 18.41798,0.207966 c 1.621003,-1.3509998 2.003924,-2.4870088 2.056924,-2.8960085 0.055,-0.4089997 -0.507966,-1.8708936 -2.157964,-1.8978936 -1.651,-0.03 -27.05496,-0.4361105 -27.05496,-0.4361105 z m 9.62093,5.63013169 c 0.707,1.0519998 0.10601,2.00195531 -1.06799,2.49995511 -1.174,0.4919997 -20.72503,8.8359045 -20.72503,8.8359045 l 53.496113,-10.68485629 z m 12.97308,4.99689781 -31.46711,6.2400238 c 0,0 22.094,-0.02604 23.776,0.002 1.684,0.027 2.55303,-0.08595 3.37504,-1.0449487 0.82,-0.9549996 4.31607,-5.1970333 4.31607,-5.1970333 z"
        />
      </g>
    </Svg>
  );
};

type LogoGLPProps = {
  className?: string;
};

export default LogoGLP;
